module.exports = __webpack_public_path__ + "static/us-enterprise-top-talent-cdb0e9a424a9e9049a31892cdd7538c4.gif";